
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'glass': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M8 0C3.591 0 0 3.591 0 8s3.591 8 8 8c1.917 0 3.678-.68 5.058-1.81l4.776 4.776a.8.8 0 1 0 1.132-1.132l-4.777-4.776A7.958 7.958 0 0 0 16 8c0-4.409-3.591-8-8-8zm0 1.6c3.544 0 6.4 2.856 6.4 6.4 0 3.544-2.856 6.4-6.4 6.4A6.388 6.388 0 0 1 1.6 8c0-3.544 2.856-6.4 6.4-6.4z"/>'
  }
})
